<template>
  <div v-if="!!(data.value instanceof Array)">
    <div v-for="text in data.value" :key="text">
      {{ text }}
    </div>
  </div>
  <div v-else>
    <div :id="`tooltipTemplate-${data.value}`" v-tippy-html class="hidden">
      <div v-if="data.tooltip" class="max-w-md w-full text-left">
        <div v-if="data.tooltip.MFR && data.tooltip.MFR != 'NULL'" class="text-xs">
          <span class=" font-bold">MFR: </span>{{ data.tooltip.MFR }}
        </div>
        <div v-if="data.tooltip.replacementProductUrl" class="sm:hidden md:hidden lg:flex">
          <trek-link xsmall qaid="grid-replacement-product-link" underline button text :href="replacementProductUrl">
            {{ data.tooltip.replacementProductText }}
          </trek-link>
        </div>
      </div>
    </div>

    <div class="flex flex-col justify-center">
      <!-- PLP and on other grids we need link on SKu to navigate to PDP-->
      <div v-if="data.link">
        <a :href="data.link" class="underline hover:no-underline" v-html="data.value" />
      </div>
      <!-- If there is no link and other columns use this -->
      <div v-else v-html="data.value" />

      <!-- Handle the tooltip for UPC and MFR with both  -->
      <div
        v-if="data.tooltip && showTooltip"
        v-tippy="{html: `#tooltipTemplate-${data.value}`, placement: 'top-start', arrow: true, interactive: true}"
      >
        <i class="b2b-grid__text__tooltip-icon material-icons text-base align-text-bottom no-underline">info</i>
      </div>
    </div>

    <div v-if="(!data.tooltip || !showTooltip) && data.type === 'date'" class="flex items-center lg:justify-end">
      <i v-show="data.warn === true" class="md-18 text-warning mr-25">warning</i>
      {{ formatDate(data.value) }}
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import TrekLink from '@/components/TrekLink';

export default {
  name: 'GridText',
  components: {TrekLink},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    showTooltip() {
      return Object.keys(this.data.tooltip).length > 0;
    },
    replacementProductUrl() {
      return this.encodedContextPath + this.data.tooltip.replacementProductUrl;
    },
    ...mapState('backend', ['encodedContextPath']),
  },
  methods: {
    formatDate: function(rawDate) {
      var date = new Date(rawDate);

      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;

      return month + '/' + day + '/' + year;
    },
  },
};
</script>
